import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import resourcesToBackend from 'i18next-resources-to-backend';
import { DEFAULT_LANGUAGE, LANGUAGE_STORAGE_KEY, SUPPORTED_LANGUAGE_CODES } from '@/i18n/languages';

type JsonDict = Record<string, unknown>;

const norm = (lng?: string) => (lng ?? 'fr').toLowerCase().split('-')[0];

void i18n
  .use(LanguageDetector)
  .use(
    resourcesToBackend(async (lng: string, ns: string) => {
      const L = norm(lng);
      try {
        const mod = await import(`./locales/${L}/${ns}.json`);
        return (mod as { default: JsonDict }).default;
      } catch {
        const fb = await import(`./locales/fr/${ns}.json`);
        return (fb as { default: JsonDict }).default;
      }
    }),
  )
  .use(initReactI18next)
  .init({
    ns: [
      'common',
      'auth',
      'register',
      'new-user',
      'user',
      'createWebinar',
      'team',
      'billing',
      'dashboard',
      'webinars',
      'analytics',
      'integrations',
      'settings',
    ],
    defaultNS: 'common',
    fallbackNS: ['common'],
    fallbackLng: DEFAULT_LANGUAGE.code,
    supportedLngs: SUPPORTED_LANGUAGE_CODES,
    nonExplicitSupportedLngs: true,
    lowerCaseLng: true,
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: LANGUAGE_STORAGE_KEY,
    },
    react: {
      useSuspense: false,
    },
    partialBundledLanguages: true,
  });

// L'attribut lang doit refléter la langue i18n courante : sinon Chrome croit voir
// une autre langue et propose la traduction auto, qui casse le DOM sous React.
const syncHtmlLang = (lng?: string) => {
  document.documentElement.lang = norm(lng || i18n.resolvedLanguage);
};
syncHtmlLang(i18n.resolvedLanguage);
i18n.on('languageChanged', syncHtmlLang);

export default i18n;
